

export const DEVICE_TYPE = {
  GATEWAY: '0', // 网关
  SUB_DEVICE: '1' // 子设备
  // 其他设备类型...
}

export const DEVICE_TYPE_LABEL = {
  [DEVICE_TYPE.GATEWAY]: '网关设备',
  [DEVICE_TYPE.SUB_DEVICE]: '子设备'
  // 其他设备类型...
}

// 统一转成字符串，0 / "0" / 都变成 "0"
export function normalizeDeviceType(type) {
  if (type === null || type === undefined || type === '') return ''
  return String(type)
}

// 获取设备类型标签
export function getDeviceTypeLabel(type, fallback = '-') {
  return DEVICE_TYPE_LABEL[normalizeDeviceType(type)] || fallback
}

// 判断是否为网关设备
export function isGateway(type) {
  return normalizeDeviceType(type) === DEVICE_TYPE.GATEWAY
}

// 判断是否为子设备
export function isSubDevice(type) {
  return normalizeDeviceType(type) === DEVICE_TYPE.SUB_DEVICE
}

// 挂到组件实例上，供 template 直接调用
export const deviceTypeMixin = {
  methods: {
    getDeviceTypeLabel,
    isGateway,
    isSubDevice
  }
}
